import { useParams } from '@tanstack/react-router';
import { useMemo } from 'react';

interface IUsePublicToken {
  suffix: string;
  token: string | string[] | null;
}

const usePublicToken = (): IUsePublicToken => {
  const params = useParams({ strict: false }) as Partial<{ publicToken?: string }>;
  const token = params.publicToken || '';
  const suffix = useMemo(() => `?token=${token}`, [token]);
  return {
    suffix: suffix,
    token: token,
  };
};

export default usePublicToken;
